export default __webpack_public_path__ + "static/0316-9c44ca2abbc56b9148665af7dd427e97.png";